import axios, { AxiosResponse } from "axios";
import { put, putResolve, select } from "redux-saga/effects";
import {
  InvalidEnum,
  ConnectionResultEnum,
 MultiMethod, MessageMethodEnum } from "redmond";
import { CipherText, Product, purchaseApi } from "@b2bportal/purchase-api";
import { getPurchaseContext } from "@capone/common";
import { actions } from "../../actions";
import { selectedTripSelector } from "../../../shop/reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import {
  getSession,
  priceQuoteParamsSelector,
  hasSMSBeenSelected,
  hasAppNotifBeenSelected,
  hasDisruptionProtectionBeenAttachedSelector,
} from "../../reducer";
import Logger from "../../../../helpers/Logger";

export function* scheduleQuoteSaga({
  agentFee,
  pollQuoteOnly,
  chfarExercise,
}: actions.IScheduleQuote) {
  try {
    const state: IStoreState = yield select();
    const session = getSession(state);
    const selectedTrip = selectedTripSelector(state);
    if (!selectedTrip) {
      Logger.debug(
        `Set schedule quote call state failed due to lack of selectedTrip`
      );
      yield put(
        actions.setScheduleQuoteCallStateFailed({
          Invalid: InvalidEnum.Missing,
          ConnectionResult: ConnectionResultEnum.Invalid,
        })
      );
    }
    if (session) {
      yield putResolve(
        actions.closeSession({
          resetSessionOnly: true,
        })
      );
    }

    const request = () => {
      const quoteParams = priceQuoteParamsSelector(state);

      const disruptionNotificationPreferences: MultiMethod = {
        email: {
          email: quoteParams.emailAddress,
          MessageMethod: MessageMethodEnum.Email,
        },
        MessageMethod: MessageMethodEnum.MultiMethod,
      };

      const sendFlightNotificationPreferences: MultiMethod = {
        email: {
          email: quoteParams.emailAddress,
          MessageMethod: MessageMethodEnum.Email,
        },
        MessageMethod: MessageMethodEnum.MultiMethod,
      };

      if (hasSMSBeenSelected(state)) {
        if (hasDisruptionProtectionBeenAttachedSelector(state)) {
          disruptionNotificationPreferences.sms = {
            MessageMethod: MessageMethodEnum.Sms,
          };
        } else {
          sendFlightNotificationPreferences.sms = {
            MessageMethod: MessageMethodEnum.Sms,
          };
        }
      }
      if (hasAppNotifBeenSelected(state)) {
        if (hasDisruptionProtectionBeenAttachedSelector(state)) {
          disruptionNotificationPreferences.push = {
            MessageMethod: MessageMethodEnum.Push,
          };
        } else {
          sendFlightNotificationPreferences.push = {
            MessageMethod: MessageMethodEnum.Push,
          };
        }
      }

      const request = {
        ...quoteParams,
        disruptionNotificationPreferences,
        sendFlightNotificationPreferences,
        chfarExercise,
      };
      return purchaseApi(axios as any).apiV0PurchaseQuoteSchedulePost({
        emailAddress: quoteParams.emailAddress,
        request: {
          type: Product.Flight,
          value: request as object,
        },
        purchaseContext: getPurchaseContext(),
      });
    };
    const result: AxiosResponse<CipherText> = yield request();

    if (result) {
      yield put(actions.setScheduleQuoteCallStateSuccess());
      yield put(actions.setSession(result.data));
      yield put(
        actions.pollQuote(agentFee, pollQuoteOnly)
      );
    } else {
      Logger.debug(`Set schedule quote call state failed due to empty result`);
      yield put(
        actions.setScheduleQuoteCallStateFailed({
          Invalid: InvalidEnum.Missing,
          ConnectionResult: ConnectionResultEnum.Invalid,
        })
      );
    }
  } catch (e) {
    Logger.debug(`Set schedule quote call state failed: ${e}`);
    yield put(
      actions.setScheduleQuoteCallStateFailed({
        Invalid: InvalidEnum.Missing,
        ConnectionResult: ConnectionResultEnum.Invalid,
      })
    );
  }
}


